import { useTranslations } from "@jugl-web/utils";
import { addDays, format } from "date-fns";

export const useDueInOptions = (allowCustomDate = true) => {
  const { t } = useTranslations();

  return {
    options: [
      {
        id: "7",
        value: t({ id: "invoices.dueInSettings.7", defaultMessage: "Net 7" }),
      },
      {
        id: "14",
        value: t({ id: "invoices.dueInSettings.14", defaultMessage: "Net 14" }),
      },
      {
        id: "30",
        value: t({ id: "invoices.dueInSettings.30", defaultMessage: "Net 30" }),
      },
      {
        id: "custom",
        value: t({
          id: "invoices.dueInSettings.custom",
          defaultMessage: "Custom",
        }),
      },
    ].filter((option) => {
      if (allowCustomDate) return true;

      return option.id !== "custom";
    }),
    getRealDate: (addedDays: string, dateTime: string): string => {
      if (!new Date(dateTime).getTime()) {
        return "";
      }

      let realDate = new Date(dateTime);

      if (!Number.isNaN(parseInt(addedDays, 10))) {
        realDate = addDays(realDate, parseInt(addedDays, 10));
      }

      return format(realDate, "dd MMM yyyy");
    },
  };
};
